export default class SezzleService {
  public init() {
    try {
      if (typeof window !== 'undefined' && window.sezzle && typeof window.sezzle.init === 'function') {
        window.sezzle.init();
      }
    } catch (error) {
      console.error('Can`t provide Sezzle script', error);
    }
  }

  public refreshUi(price: string) {
    try {
      if (typeof window !== 'undefined' && window.sezzle && typeof window.sezzle.alterPrice === 'function') {
        window.sezzle.alterPrice(`$${price}`);
      }
    } catch (error) {
      console.error('Can`t provide Sezzle script', error);
    }
  }
}
